import ZodiacGlyph from './ZodiacGlyph'

export default function ZodiacCard({ sign, energy, loading, active, onSelect }) {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`zodiac-card group bg-white shadow-sm border rounded-2xl p-6 flex flex-col items-center justify-center text-center cursor-pointer transition-all duration-500 hover:shadow-xl hover:shadow-amber-100/80 hover:-translate-y-2 select-none ${
        active ? 'border-amber-400 shadow-xl shadow-amber-100/80 -translate-y-2' : 'border-gray-100 hover:border-amber-300'
      }`}
      data-sign={sign.sign}
      data-rashi={sign.rashi}
    >
      <div
        className={`w-20 h-20 sm:w-14 sm:h-14 rounded-full flex items-center justify-center shadow-sm border border-amber-100 transition-all duration-700 ease-in-out group-hover:rotate-360 group-hover:scale-110 ${
          active ? 'bg-amber-500 text-white' : 'bg-amber-50 group-hover:bg-amber-500 text-amber-500 group-hover:text-white'
        }`}
      >
        <ZodiacGlyph sign={sign.sign} className="w-8 h-8 sm:w-6 sm:h-6" />
      </div>
      <h3
        className={`font-royal text-sm md:text-base font-bold tracking-wide mt-4 uppercase transition-colors ${
          active ? 'text-amber-600' : 'text-gray-800 group-hover:text-amber-600'
        }`}
      >
        {sign.rashi}
      </h3>
      <p className="text-[10px] font-medium text-amber-500 tracking-widest uppercase mt-0.5">{sign.sign}</p>
      <p className="text-[9px] text-gray-400 font-light mt-1.5 tracking-wider">{sign.dates}</p>

      {loading && <div className="w-full h-1 rounded-full bg-amber-100 animate-pulse mt-3.5" aria-hidden="true" />}
      {typeof energy === 'number' && (
        <div className="w-full mt-3">
          <div className="flex items-center justify-between text-[7.5px] uppercase tracking-wider font-semibold mb-1">
            <span className="text-gray-400">Today&apos;s Energy</span>
            <span className="text-amber-600">{energy}%</span>
          </div>
          <div className="h-1 rounded-full bg-amber-100 overflow-hidden">
            <div
              className="h-full rounded-full bg-linear-to-r from-goldAccent to-goldPrimary transition-all duration-700"
              style={{ width: `${energy}%` }}
            />
          </div>
        </div>
      )}
    </button>
  )
}
